import { render, staticRenderFns } from "./PxCamposCompraProdutosViewUseall.vue?vue&type=template&id=4b78aa71&"
import script from "./PxCamposCompraProdutosViewUseall.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraProdutosViewUseall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports